<template>
  <div class="px-2">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#9E6D2B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#9E6D2B" right :timeout="timeout">
      <span style="color: #FFFFFF; font-weight: 600;">{{ msg }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text color="#FFFFFF" v-bind="attrs" @click="showsnackbar = false">
          <v-icon style="color: #FFFFFF">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- TOP HEADER & CONTROLS -->
    <v-row align="center" justify="space-between" class="mb-3">
      <v-col cols="12" sm="4" md="4" class="py-1">
        <span class="mainHeader">Supplier Wise Report</span>
      </v-col>
      <v-col cols="12" sm="8" md="8" class="d-flex align-center justify-end py-1" style="gap: 12px; flex-wrap: wrap;">
        <!-- From Date -->
        <div style="width: 160px;">
          <v-menu
            ref="fromMenu"
            v-model="fromMenu"
            :close-on-content-click="false"
            :return-value.sync="from"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="from"
                label="From Date"
                outlined
                dense
                readonly
                hide-details
                background-color="#FFFFFF"
                v-bind="attrs"
                v-on="on"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="from"
              no-title
              scrollable
              color="#9E6D2B"
              @change="$refs.fromMenu.save(from)"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>

        <!-- To Date -->
        <div style="width: 160px;">
          <v-menu
            ref="toMenu"
            v-model="toMenu"
            :close-on-content-click="false"
            :return-value.sync="to"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="to"
                label="To Date"
                outlined
                dense
                readonly
                hide-details
                background-color="#FFFFFF"
                v-bind="attrs"
                v-on="on"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="to"
              no-title
              scrollable
              color="#9E6D2B"
              @change="$refs.toMenu.save(to)"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>

        <!-- Download PDF Button -->
        <v-btn
          color="#9E6D2B"
          dark
          height="40"
          elevation="1"
          class="text-none font-weight-bold px-4"
          style="border-radius: 8px;"
          @click="download"
          :disabled="appLoading"
        >
          <v-icon left small>mdi-file-pdf-box</v-icon>
          Download PDF
        </v-btn>
      </v-col>
    </v-row>

    <!-- NO DATA STATE -->
    <div v-if="!appLoading && supplierRows.length === 0" class="no-data-box text-center py-8 my-4">
      <v-icon color="#9E6D2B" class="mb-2">mdi-information-outline</v-icon>
      <div class="no-data-text">No supplier purchases found for the selected date range.</div>
    </div>

    <!-- MAIN SUPPLIER REPORT TABLE CARD -->
    <v-card v-if="supplierRows.length > 0" outlined class="rounded-lg overflow-hidden elevation-1 mb-5" color="#FFFFFF">
      <div class="table-container">
        <table class="supplier-report-table">
          <thead>
            <tr>
              <th class="text-left">SUPPLIER NAME</th>
              <th class="text-center">BILLS</th>
              <th class="text-right">TOTAL PURCHASE (₹)</th>
              <th class="text-right">AMOUNT PAID (₹)</th>
              <th class="text-right">BALANCE DUE (₹)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rIdx) in supplierRows" :key="rIdx" class="table-row">
              <td class="text-left font-weight-semibold supplier-name-cell">
                {{ row.supplier || 'Unassigned Supplier' }}
              </td>
              <td class="text-center">
                <span class="bills-badge">{{ row.bills || 0 }}</span>
              </td>
              <td class="text-right font-weight-medium">
                ₹{{ formatCurrency(row.totalPurchase) }}
              </td>
              <td class="text-right text-success-val">
                ₹{{ formatCurrency(row.paid) }}
              </td>
              <td class="text-right">
                <span :class="row.balance > 0 ? 'balance-due-text' : 'balance-clear-text'">
                  ₹{{ formatCurrency(row.balance) }}
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="totals-row">
              <td class="text-left total-label-cell">GRAND TOTAL</td>
              <td class="text-center"><strong>{{ totals.billCount || 0 }}</strong></td>
              <td class="text-right"><strong>₹{{ formatCurrency(totals.totalAmount) }}</strong></td>
              <td class="text-right"><strong>₹{{ formatCurrency(totals.paid) }}</strong></td>
              <td class="text-right total-balance-cell"><strong>₹{{ formatCurrency(totals.balance) }}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SupplierWiseReportPage",
  data() {
    var today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10);
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      fromMenu: false,
      toMenu: false,
      from: today,
      to: today,
      supplierRows: [],
      totals: { billCount: 0, totalAmount: 0, paid: 0, balance: 0 },
    };
  },
  watch: {
    from() {
      this.getList();
    },
    to() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    formatCurrency(val) {
      const num = Number(val) || 0;
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getList() {
      if (!this.from || !this.to) return;
      this.appLoading = true;
      axios({
        method: "get",
        url: "/data/supplierwisereport",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: {
          from: this.from,
          to: this.to,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data && response.data.status) {
            this.supplierRows = response.data.data.supplierRows || [];
            this.totals = response.data.data.totals || { billCount: 0, totalAmount: 0, paid: 0, balance: 0 };
          } else {
            this.msg = (response.data && response.data.msg) || "Failed to fetch report data";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    download() {
      if (!this.from || !this.to) {
        this.msg = "Please choose both dates";
        this.showsnackbar = true;
        return;
      }
      this.appLoading = true;
      axios({
        method: "get",
        url: "/download/supplierwisereport",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          from: this.from,
          to: this.to,
        },
        responseType: "blob",
      })
        .then((response) => {
          this.appLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `SupplierWiseReport_${this.from}_to_${this.to}.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

.mainHeader {
  font-family: 'Cinzel', serif;
  font-size: 22px;
  font-weight: 700;
  color: #1E1815;
  letter-spacing: 0.3px;
}

.no-data-box {
  background: #FFFFFF;
  border: 1px solid #EFE8DD;
  border-radius: 8px;
}

.no-data-text {
  font-size: 14px;
  color: #8C7D6F;
  font-weight: 500;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

.supplier-report-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13.5px;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.supplier-report-table th {
  background: #FAF8F5;
  color: #6B5738;
  font-size: 11.5px;
  font-weight: 700;
  padding: 10px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #EFE8DD;
  white-space: nowrap;
  letter-spacing: 0.4px;
}

.supplier-report-table td {
  padding: 11px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #F3EFE8;
  white-space: nowrap;
  color: #1E1815;
}

.table-row:hover td {
  background-color: #FAF5EA !important;
}

.supplier-name-cell {
  color: #1E1815;
  text-transform: capitalize;
}

.bills-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  background: #F4ECE0;
  color: #7D551E;
  font-size: 12px;
  font-weight: 700;
}

.text-success-val {
  color: #047857;
  font-weight: 500;
}

.balance-due-text {
  color: #D97706;
  font-weight: 700;
}

.balance-clear-text {
  color: #6B7280;
  font-weight: 500;
}

.totals-row td {
  background-color: #F7F2E8 !important;
  border-top: 2px solid #9E6D2B !important;
  border-bottom: none !important;
  color: #1E1815;
  font-weight: 700;
  padding: 12px 16px;
  font-size: 14px;
}

.total-label-cell {
  color: #9E6D2B !important;
  font-family: 'Cinzel', serif;
  font-size: 13.5px !important;
  font-weight: 700;
}

.total-balance-cell {
  color: #9E6D2B !important;
}
</style>
